import loadjs from 'loadjs';
import { expandCollapseManager } from '@wix/chat-web';
import { loadingScheduler } from './services/loading-scheduler';
import wix from './services/wix';

const loadConnectivityPrerequisiteScripts = ({ unpkgUrl }) => {
  return new Promise(resolve => {
    const files = [
      `${unpkgUrl}/firebase@5.7.3/firebase-app.js`,
      `${unpkgUrl}/firebase@5.7.3/firebase-auth.js`,
      `${unpkgUrl}/firebase@5.7.3/firebase-database.js`,
    ];
    loadjs(files, {
      async: false,
      numRetries: 3,
      before: (path, scriptEl) => {
        scriptEl.crossOrigin = true;
      },
      success: () => {
        resolve();
      },
    });
  });
};

export const triggerInteractivity = () =>
  void loadingScheduler
    .onConnective()
    .then(loadingScheduler.triggerInteractivity);

export const loadChat = ({ widgetMode, experiments, unpkgUrl }) => {
  const shouldLazyLoadFirebase =
    widgetMode === 'site' &&
    experiments['specs.chat.LazilyLoadFirebase'] === 'true';

  if (shouldLazyLoadFirebase) {
    void loadConnectivityPrerequisiteScripts({ unpkgUrl }).then(
      loadingScheduler.triggerConnectivity,
    );
  } else {
    loadingScheduler.triggerConnectivity();
  }

  const shouldLazyLoadChat =
    widgetMode === 'site' &&
    experiments['specs.chat.LazilyInteractiveWidget'] === 'true';

  if (shouldLazyLoadChat) {
    const triggerInteractivityHandler = () => {
      triggerInteractivity();
      window.removeEventListener('mouseover', triggerInteractivityHandler);
      expandCollapseManager.unregisterOnExpand(triggerInteractivityHandler);
    };
    window.addEventListener('mouseover', triggerInteractivityHandler);
    expandCollapseManager.registerOnExpand(triggerInteractivityHandler);
    window.setTimeout(triggerInteractivityHandler, 15e3);
  } else {
    void loadingScheduler.onConnective().then(() => {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(triggerInteractivity);
      }
      wix.onReady(triggerInteractivity);
    });
  }
};
